import { IRecordType } from './recordType';

export interface IGetItemActions {
    SaasMyRoleMenuItemActions: RoleItemActions[];
}

export interface RoleItemActions {
    id: string;
    menuItem: IMenuItemRoleActions;
    role: IRolefromRoleActions;
    menuItemActions: IMenuItemActionRoleActions[];
}
export interface IMenuItemRoleActions {
    id: string;
    name: string;
    recordType?: Pick<IRecordType, 'id'>;
}
export interface IRolefromRoleActions {
    id: string;
    name: string;
}
export interface IMenuItemActionRoleActions {
    id: string;
    name: RoleActionValues | string;
    enabled?: boolean;
}

export const ROLE_ACTIONS = {
    ACCESS: 'Access',
    BULK_IMPORT_RECORDS: 'Bulk Import Records',
    ENRICH_RECORD_DATA: 'Enrich Record Data',
    IMPORT_LINE_ITEMS: 'Import Line Items',
    RECORD_SOFT_DELETE: 'Record Soft Delete',
    LINE_ITEM_ACCESS: 'Line Item Access',
    CONFIGURE_USER_GRID_PREFERENCES: 'Configure User Grid Preferences',
    DATA_FOCUS_VIEW: 'Data Focus View',
    CREATE_RECORDS: 'Create Records',
    RECORD_VIEWER_ACCESS: 'Record Viewer Access',
    DYNAMIC_DATA_VIEWS: 'Dynamic Data Views',
    BULK_DOWNLOAD: 'Bulk Download',
    BULK_UPDATE: 'Bulk Update',
    LOG_REPORT_ACCESS: 'Log Report Access',
    ENTITIES_ACCESS: 'Entities Access',
    PDF_RECORD_VIEW: 'PDF Record View',
    EDIT_LINE_ITEMS: 'Edit Line Items',
    EXPORT_LINE_ITEMS: 'Export Line Items'
} as const;

export type RoleActionEnum = keyof typeof ROLE_ACTIONS;
export type RoleActionValues = (typeof ROLE_ACTIONS)[RoleActionEnum];
